import {remCalc} from '../../_utils'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {SFCC_ORDER_STATUS} from '../../../pages/account/constant'

export default {
    baseStyle: {
        itemContainer: {
            w: {
                lg: 'auto',
                md: 'auto',
                sm: 'auto',
                base: 'auto',
            },
            height: 'auto',
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: {
                lg: remCalc(24),
                md: remCalc(16),
                sm: remCalc(16),
                base: remCalc(16),
            },
            minWidth: {
                lg: remCalc(476),
                md: remCalc(150),
                sm: remCalc(150),
                base: remCalc(150),
            },
        },
        infoLabelContainer: {
            flexDir: 'row',
            gap: 'xsmall.base',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
        },
        productLabel: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: remCalc(168),
            paddingY: remCalc(6),
            paddingX: remCalc(8),
            gap: remCalc(12),
            bg: 'background.light-blue',
        },
        discount: {
            flex: '1 0 0',
            color: 'text.secondary',
            textStyle: 'body-xxsmall',
            fontWeight: 'bold',
        },
        flexContainer: {
            w: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            gap: {
                lg: remCalc(26),
                md: remCalc(24),
                sm: remCalc(16),
                base: remCalc(16),
            },
            bg: 'background.default',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            paddingBottom: {base: remCalc(20)},
        },
        cartImage: {
            width: {
                lg: remCalc(212),
                md: remCalc(109),
                sm: remCalc(109),
                base: remCalc(109),
            },
            height: {
                lg: remCalc(212),
                md: remCalc(109),
                sm: remCalc(109),
                base: remCalc(109),
            },
            objectFit: 'cover',
        },
        itemName: {
            flex: '1 0 0',
            color: 'text.default',
            textStyle: 'head-xsmall',
            fontWeight: 'medium',
            minWidth: remCalc(179),
        },
        removeIcon: {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: {
                lg: 'center',
                md: 'flex-end',
                sm: 'flex-end',
                base: 'flex-end',
            },
            gap: remCalc(18),
        },
        detailContainer: {
            display: 'flex',
            w: '100%',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: {
                lg: 'xsmall.lg',
                md: 'xsmall.md',
                sm: 'xsmall.sm',
                base: 'xsmall.base',
            },
        },
        headerStack: {
            display: 'flex',
            justifyContent: 'space-between',
            alignSelf: 'stretch',
        },
        omniAndPrice: {
            display: 'flex',
            flexDir: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: 'xsmall.base',
            flexWrap: 'wrap',
        },
        vatDetails: {
            display: 'flex',
            width: {
                lg: remCalc(164),
                md: remCalc(164),
            },
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: remCalc(10),
        },
        itemPrice: {
            color: 'text.default',
            textStyle: 'body-medium',
            fontWeight: 'normal',
            textAlign: 'left',
        },
        omnibus: {
            display: 'flex',
            flexDir: {
                lg: 'row',
                md: 'column',
                sm: 'column',
                base: 'column',
            },
            textAlign: 'left',
            width: {
                lg: remCalc(154),
                md: remCalc(95),
                sm: remCalc(95),
                base: remCalc(95),
            },
            height: {
                lg: remCalc(14),
                md: remCalc(32),
                sm: remCalc(32),
                base: remCalc(32),
            },
            flexShrink: 0,
            gap: {
                lg: 'xxsmall.lg',
                md: 'xxsmall.md',
                sm: 'xxsmall.sm',
                base: 'xxsmall.base',
            },
        },
        suggestedPrice: {
            textAlign: 'left',
            textDecorationLine: 'line-through',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        suggestedText: {
            whiteSpace: 'nowrap',
            textAlign: 'left',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
        },
        vatText: {
            color: 'text.default',
            flex: '1 0 0',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        textQuantity: {
            color: 'text.default',
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
        },
        quantSelContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(12),
        },
        officinaLink: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: remCalc(10),
            color: 'text.tertiary',
            textStyle: 'body-small',
            fontWeight: 'bold',
            textDecoration: 'underline',
        },
        subAndSaveText: {
            textStyle: 'body-xsmall',
            fontFamily: 'secondary',
            fontWeight: 'bold',
            color: '#000',
        },
        subAndSaveButton: {
            textStyle: 'body-small',
        },
    },
    variants: {
        subscriptions: {
            omnibus: {
                width: 'fit-content',
                height: 'unset',
                flexDir: 'row',
                gap: remCalc(8),
            },
            omniAndPrice: {
                flexDir: 'row',
                gap: 0,
                textStyle: 'body-medium',
            },
            recurringPrice: {
                textDecorationLine: 'line-through',
            },
            popoverContainer: {
                display: 'flex',
                alignItems: 'center',
                gap: remCalc(8),
                textStyle: 'body-xsmall',
            },
            longDescriptionContainer: {
                listStylePosition: 'inside',
                textStyle: 'body-xsmall',
            },
            discountDescriptionContainer: {
                textStyle: 'body-xsmall',
            },
        },
        subscriptionsMiniCart: {
            flexContainer: {
                gap: remCalc(9),
                pt: remCalc(16),
                pb: remCalc(16),
            },
            detailContainer: {
                gap: remCalc(8),
                width: remCalc(187),
            },
            cartImage: {
                width: remCalc(138),
                height: remCalc(138),
                objectFit: 'cover',
            },
            itemName: {
                color: 'text.default',
                fontSize: remCalc(18),
                lineHeight: remCalc(20),
                fontWeight: 'bold',
            },
            recurringPrice: {
                textDecorationLine: 'line-through',
                fontSize: remCalc(12),
            },
            longDescriptionContainer: {
                listStylePosition: 'inside',
                textStyle: 'body-xsmall',
            },
            discountDescriptionContainer: {
                textStyle: 'body-xsmall',
            },
            omniAndPrice: {
                flexDir: 'row',
                gap: 0,
                alignItems: 'center',
            },
            omnibus: {
                w: 'fit-content',
                alignItems: 'center',
            },
        },
        subscriptionsOrderSummary: {
            cartImage: {
                width: remCalc(109),
                height: remCalc(109),
                objectFit: 'cover',
            },
            flexContainer: {
                gap: remCalc(16),
                pb: remCalc(0),
                backgroundColor: 'transparent',
                borderBottom: 'none',
            },
            detailContainer: {
                gap: remCalc(12),
            },
            itemName: {
                color: 'text.default',
                fontSize: remCalc(16),
                lineHeight: remCalc(20),
                fontWeight: 'bold',
            },
            recurringPrice: {
                textDecorationLine: 'line-through',
            },
            omnibus: {
                width: 'fit-content',
            },
            omniAndPrice: {
                fontSize: remCalc(12),
                flexDir: 'row',
                gap: 0,
            },
            longDescriptionContainer: {
                listStylePosition: 'inside',
                textStyle: 'body-xsmall',
            },
        },
        subscriptionsConfirmation: {
            cartImage: {
                width: remCalc(109),
                height: remCalc(109),
                objectFit: 'cover',
            },
            flexContainer: {
                gap: remCalc(24),
            },
            detailContainer: {
                gap: remCalc(12),
            },
            itemName: {
                color: 'text.default',
                fontSize: remCalc(16),
                lineHeight: remCalc(20),
                fontWeight: 'normal',
            },
            recurringPrice: {
                textDecorationLine: 'line-through',
            },
            omnibus: {
                width: 'fit-content',
            },
            omniAndPrice: {
                fontSize: remCalc(16),
                flexDir: 'row',
                gap: 0,
            },
            longDescriptionContainer: {
                listStylePosition: 'inside',
                textStyle: 'body-xsmall',
            },
        },
        OrderDetail: ({
            status,
            isMultipleShipment,
            isReturnOrderForm,
            isReturnOrder,
        }: {
            status: string
            isMultipleShipment: boolean
            isReturnOrderForm?: boolean
            isReturnOrder?: boolean
        }) => ({
            flexContainer: {
                gap: {
                    base: remCalc(12),
                    sm: remCalc(12),
                },
                paddingBottom: {base: remCalc(16), md: remCalc(24), lg: remCalc(24)},
                paddingTop: isReturnOrderForm
                    ? remCalc(24)
                    : isReturnOrder
                    ? {base: remCalc(32), md: remCalc(20), lg: remCalc(20)}
                    : {base: remCalc(32), md: remCalc(48), lg: remCalc(48)},
                paddingX: {base: remCalc(4), lg: 0},
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit',
                ...(isMultipleShipment
                    ? {
                          borderBottom: 'unset',
                          borderStyle: 'unset',
                          borderColor: 'unset',
                          backgroundColor: 'inherit',
                      }
                    : {
                          '&:last-of-type': {
                              borderBottom: 'unset',
                              borderStyle: 'unset',
                              borderColor: 'unset',
                              paddingBottom: {base: remCalc(32), md: remCalc(24), lg: remCalc(24)},
                          },
                      }),
            },
            detailContainer: {
                gap: {
                    base: remCalc(12),
                    sm: remCalc(12),
                },
                color:
                    status === SFCC_ORDER_STATUS.CANCELLED || status === SFCC_ORDER_STATUS.FAILED
                        ? 'text.secondary'
                        : 'text.default',
            },
            itemName: {
                color: 'inherit',
                alignSelf: 'stretch',
                maxWidth: remCalc(300),
            },
            itemCode: {
                textStyle: 'body-xsmall',
                color: 'text.secondary',
                fontWeight: 'normal',
            },
            textQuantity: {
                color: 'inherit',
            },
            vatDetails: {
                width: 'auto',
                color:
                    status === SFCC_ORDER_STATUS.CANCELLED || status === SFCC_ORDER_STATUS.FAILED
                        ? 'text.secondary'
                        : 'text.default',
            },
            productImage: {
                flexBasis: isReturnOrderForm
                    ? {base: remCalc(100), md: remCalc(120)}
                    : {base: remCalc(109), md: remCalc(212)},
                h: isReturnOrderForm
                    ? {base: remCalc(100), md: remCalc(120)}
                    : {base: remCalc(109), md: remCalc(212)},
                flexShrink: '0',
                alignSelf: isReturnOrderForm
                    ? 'flex-start'
                    : ['flex-start', 'flex-start', 'flex-start', 'unset'],
            },
        }),
    },
}
